import React from 'react'
import Modal from 'LuxKit/Modal/Modal'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import HelpPane from 'components/Common/HelpPane'

const ModalContent = styled.div`
  padding-top: ${rem(16)};
`

interface Props {
  title: string
  hideExcludesFlights: boolean
  cancellationPolicyType?: App.CancellationPolicyType
  cancellationPolicyLines?: Array<string>
}

function ConnectionCancellationPolicyModal(props: Props) {
  const {
    title,
    hideExcludesFlights,
    cancellationPolicyType,
    cancellationPolicyLines,
  } = props

  return <Modal
    title={title}
  >
    <ModalContent>
      {cancellationPolicyLines?.map(line => <BodyText variant="large" as="p" key={line}>{ line }</BodyText>)}
      {cancellationPolicyType == 'dynamic' &&
        <BodyText variant="large" as="p">Please note: cancellation policies apply to accommodation bookings only{hideExcludesFlights ? '' : ', excludes flights'}.</BodyText>}
      <HelpPane />
    </ModalContent>
  </Modal>
}

export default ConnectionCancellationPolicyModal
